export const validation = {
  titleMaxChar: 50,
  gallery: {
    min: 1,
    max: 5
  }
}
